// Screen `import` — design/screens/ImportWizard.dc.html — owner: S6.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ImportWizard } from '../../../../features/import/ImportWizard';

const Search = z.looseObject({
  id: z.uuid().optional().catch(undefined),
  step: z.enum(['upload', 'map', 'match', 'review']).optional().catch(undefined),
});

export const Route = createFileRoute('/_focus/o/$object/import')({
  validateSearch: (search) => Search.parse(search),
  component: ImportPage,
});

function ImportPage() {
  const { object } = Route.useParams();
  const { id, step } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ImportWizard
      objectKey={object}
      importId={id}
      step={step ?? (id ? 'map' : 'upload')}
      onNavigate={(next) => void navigate({ search: { id: next.id, step: next.step } })}
    />
  );
}
